module.exports = __webpack_public_path__ + "static/media/microscopy-nsit0108-01 7.917d1b65.png";